<template>
    <div class="com-selector">
        <transition name="fade">
            <div v-show="showPicker" class="selector-roll" @touchstart.prevent="close">
                <div class="selector-main" @touchstart.stop>
                    <div class="selector-top">
                        <div>
                            <span class="selector-title">{{ pickerTitle }}</span>
                            <span class="icon-close" @click.prevent="close"></span>
                        </div>
                    </div>
                    <div class="selector-content">
                        <div class="selector-area">
                            <div>
                                <Picker v-show="showPicker" ref="comPicker" :slots="listSlots"> </Picker>
                            </div>
                        </div>
                    </div>
                    <div class="selector-bottom">
                        <div class="btn-confirm" :class="{ active: enableBtn }">
                            <span @click="confirm">确认</span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { Picker } from 'mint-ui'
export default {
    name: 'ComSelector',
    components: {
        Picker
    },
    props: {
        showPicker: {
            type: Boolean
        },
        pickerTitle: {
            type: String,
            default: ''
        },
        pickerList: {
            type: Array
        },
        selectPicker: {
            default: ''
        }
    },
    data() {
        return {
            listSlots: [
                {
                    flex: 1,
                    values: [],
                    className: 'slot1',
                    textAlign: 'center'
                }
            ],
            enableBtn: true
        }
    },
    watch: {
        pickerList: {
            handler(val) {
                this.$nextTick(() => {
                    this.$refs.comPicker.setSlotValues(0, val)
                    this.$refs.comPicker.setSlotValue(0, val[0])
                })
            },
            deep: true,
            immediate: true
        },
        showPicker(val) {
            if (val) {
                this.$refs.comPicker.setSlotValue(0, this.selectPicker)
            }
        }
    },
    methods: {
        close() {
            this.$emit('closePicker')
        },
        confirm() {
            this.$emit('confirmPicker', this.$refs.comPicker.getValues()[0])
        }
    }
}
</script>

<style lang="scss" scoped>
.com-selector {
    .selector-roll {
        position: fixed;
        z-index: 999;
        width: 100%;
        top: 0;
        bottom: 0;
        max-width: 7.5rem;
        color: #000;
        background: rgba(0, 0, 0, 0.5);
        .selector-main {
            position: fixed;
            bottom: 0;
            width: 100%;
            min-height: 5rem;
            display: flex;
            flex-flow: column nowrap;
            background: #fff;
            border-radius: 0.08rem 0.08rem 0 0;
            .selector-top {
                position: relative;
                text-indent: 1ch;
                font-size: 0.3rem;
                color: #111111;
                font-weight: 800;
                padding: 0.34rem 0.1rem;
                border-bottom: 0.04rem solid #f8f9fa;
                div {
                    position: relative;
                    .icon-close {
                        position: absolute;
                        top: -0.05rem;
                        right: 0.2rem;
                        width: 0.5rem;
                        height: 0.5rem;
                        &:before {
                            position: absolute;
                            top: 50%;
                            content: '';
                            display: block;
                            height: 5px;
                            width: 0.36rem;
                            background: #000;
                            transform: rotate(45deg);
                        }
                        &:after {
                            position: absolute;
                            top: 50%;
                            content: '';
                            display: block;
                            height: 5px;
                            width: 0.36rem;
                            background: #000;
                            transform: rotate(-45deg);
                        }
                    }
                }
            }
            .selector-content {
                padding: 0.2rem 0.3rem 0;
                .selector-area {
                    position: relative;
                    height: 4rem;
                    >>> .picker {
                        position: relative;
                        width: 100%;
                        z-index: 1;
                    }
                    >>> .picker-item {
                        color: #707274;
                        &.picker-selected {
                            color: #dc1e32;
                        }
                    }
                }
            }
            .selector-bottom {
                z-index: 99;
                background: #fff;
                .btn-confirm {
                    padding: 0.2rem.5rem;
                    >>> span {
                        display: inline-block;
                        width: 100%;
                        border-radius: 0.48rem;
                        text-align: center;
                        color: #fff;
                        font: bold 0.34rem/3 YaHei;
                        letter-spacing: 0.5rem;
                        text-indent: 0.5rem;
                        background: rgba(0, 0, 0, 0.3);
                    }
                    &.active {
                        >>> span {
                            background: #dc1e32;
                            color: #ffffff;
                        }
                    }
                }
            }
        }
    }
    ::-webkit-scrollbar {
        display: none;
    }
    .fade-enter-active,
    .fade-leave-active {
        bottom: 0;
        opacity: 1;
        transition: all 0.3s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        bottom: -100vh;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/comSelector/index.vue